import { render, staticRenderFns } from "./AttendeeInfoModal.vue?vue&type=template&id=21b882be&"
import script from "./AttendeeInfoModal.vue?vue&type=script&lang=js&"
export * from "./AttendeeInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports